/* F&NT · Abre el carrito lateral al llegar con ?abrir_carrito=1
   Lo usan los correos de recompra (Klaviyo, R1/R2): el botón REPETIR MI PEDIDO
   agrega los productos con /cart/add y regresa aquí. Para revertir, quita la línea
   que carga este archivo en layout/theme.liquid. (2026-09-22) */
(function () {
  var params = new URLSearchParams(window.location.search);
  if (!params.has('abrir_carrito')) return;

  // Limpia la dirección para que al recargar o compartir no se vuelva a abrir
  params.delete('abrir_carrito');
  var query = params.toString();
  history.replaceState(null, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);

  function abrir() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') drawer.open();
  }

  customElements.whenDefined('cart-drawer-component').then(function () {
    if (document.readyState === 'complete') {
      setTimeout(abrir, 200);
    } else {
      window.addEventListener('load', function () { setTimeout(abrir, 200); }, { once: true });
    }
  });
})();
